import FilterIcon from '@components/icons/Filter.svg';
import { TProps } from './types/TProps';

export const Filter = ({ onClick, filterCounter = 0 }: TProps) => {
  if (!onClick) {
    return null;
  }

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Filter"
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.currentTarget.click();
        }
      }}
      onClick={onClick}
      className="flex min-h-11 min-w-11 items-center justify-center relative cursor-pointer p-[6px] hover:bg-[var(--color-tint)] text-[var(--color-text-muted)] hover:text-[var(--color-on-surface)] hover:rounded-[5px] group"
    >
      <FilterIcon />
      {filterCounter ? (
        <div className="absolute top-1/2 right-1/2 text-white bg-[var(--color-tint)] w-4 text-[10px] leading-4 text-center rounded-full font-semibold font-[Arial] translate-x-[17px] -translate-y-[17px] transition-opacity duration-75 group-hover:opacity-0">
          {filterCounter}
        </div>
      ) : null}
    </div>
  );
};
